import SEO from '../../components/base/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import BasicSpecs from './components/BasicSpecs';
import Merits from './components/Merits';
import PointGuide from './components/PointGuide';
import Demerits from './components/Demerits';
import Reviews from './components/Reviews';
import SuitableFor from './components/SuitableFor';
import HowToApply from './components/HowToApply';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';

export default function JaccsCard() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    "name": "ジャックス Gold Time",
    "description": "ジャックスが発行するゴールドカード。豊富なポイント特典と充実した付帯保険が特徴。旅行・ショッピング・日常使いにも対応した総合カードです。",
    "brand": {
      "@type": "Brand",
      "name": "ジャックス"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "JPY",
      "availability": "https://schema.org/InStock"
    },
    "url": `${siteUrl}/jaccs`
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="ジャックス Gold Time詳細｜ポイント・保険・特典を徹底解説｜クレカ比較ナビ"
        description="ジャックス Gold Timeクレジットカードの詳細情報。ポイント還元率、付帯保険、各種特典、申込条件、審査情報を徹底解説。メリット・デメリット・口コミも掲載。"
        keywords="ジャックスカード,Gold Time,ゴールドカード,ポイント還元,付帯保険,クレジットカード"
        canonical="/jaccs"
        structuredData={structuredData}
      />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: 'カード詳細', path: '/ranking' },
        { label: 'ジャックス Gold Time' }
      ]} />
      <Hero />
      <CTASection />
      <BasicSpecs />
      <Merits />
      <PointGuide />
      <Demerits />
      <CTASection />
      <Reviews />
      <SuitableFor />
      <HowToApply />
      <CTASection />
      <Footer />
    </div>
  );
}
